export default __webpack_public_path__ + "static/media/nodejs.b7d2308b.svg";